// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2mwvS","container":"styles_container__2ANpi","title":"styles_title__az0aq","wrapper":"styles_wrapper__3W0Vm","answer":"styles_answer__2pO5Y"};